import { AdminTemplateOptions } from "../includes/types/Config";
import { baseTemplateRoutes } from "./baseTemplateRoutes"

const registerRoutes = (options: AdminTemplateOptions): void => {
  options.router.addRoutes(options.config.routes.concat(baseTemplateRoutes))
}

export default registerRoutes
